import { dataRankingColumns, getDataRankingConfig } from "../../ranking.config";
import { PoolStanding } from "../../../../api/client/Api";
import { S3Image } from "../../../../components/S3Image";

interface PoolRankingProps {
  pool: PoolStanding;
}

const PoolRanking = ({ pool }: PoolRankingProps) => {
  return (
    <div>
      <div className="flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Position
                    </th>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Équipe
                    </th>
                    {dataRankingColumns.map((column) => (
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {column}
                      </th>
                    ))}

                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      PTS
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {pool.teams.map((ranking, index) => {
                    const data = getDataRankingConfig(ranking);
                    return (
                      <tr key={ranking.team_id}>
                        {/* Position */}
                        <td className="whitespace-nowrap py-4">
                          <p className="text-blue-800 text-center text-2xl font-semibold">
                            {ranking.rank || index + 1}
                          </p>
                        </td>
                        {/* Équipe */}
                        <td className="py-4 min-w-[120px] w-[200px] max-w-[250px]">
                          <div className="flex items-center">
                            <div className="h-10 w-10 flex-shrink-0">
                              {ranking.team_logo_key ? (
                                <S3Image
                                  className="h-10 w-10 rounded object-contain"
                                  keyPath={ranking.team_logo_key}
                                  alt={ranking.team_name}
                                />
                              ) : (
                                <div className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 rounded-full object-contain pr-1 bg-gray-100" />
                              )}
                            </div>
                            <div className="ml-4 min-w-0 flex-1">
                              <div className="truncate md:line-clamp-2 font-medium text-gray-900 text-sm">
                                {ranking.team_name}
                              </div>
                            </div>
                          </div>
                        </td>
                        {data.map(({ value }) => (
                          <td className="whitespace-nowrap px-3 py-4 text-sm">
                            <p className="text-xl font-semibold text-gray-500">
                              {value || "0"}
                            </p>
                          </td>
                        ))}

                        {/* Points */}
                        <td className="whitespace-nowrap px-3 py-4 text-sm">
                          <dd className="mt-1 text-3xl font-semibold tracking-tight text-blue-600">
                            {ranking.points || "0"}
                          </dd>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoolRanking;
